import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import { CanChuyenParamGroup } from "./workingTypes";
import './ThamSoTheoLoaiCuocMB.scss'
import LotSelect from "../ui/lotSelect";
type OwnProps = {
    param: CanChuyenParamGroup;
    onDataChange: (param: CanChuyenParamGroup) => void;
}

const ThamSoTheoLoaiCuocMB: FC<OwnProps> = ({
    param,
    onDataChange,
}) => {
    const options = (param: CanChuyenParamGroup) => {
        const dataValue = param.kieuGiu
        let showConThu = false;
        switch (param.subGroup) {
            case "De": case "DeA": case "Lo": case "LoA":
            case "Giai1": case "Giai1A":case "Giai2":case "Giai3":
                showConThu = true;
                break;
        }
        const result = []
        result.push(<option value="DIEM" selected={dataValue == "DIEM"}>Điểm</option>)
        result.push(<option value="PT" selected={dataValue == "PT"}>%</option>)
        if (showConThu) {
            result.push(<option value="STT" selected={dataValue == "STT"}>Số TT</option>)
        }


        return result
    }
    return (
        <div className="mb-ts-item-container">
            <div className="mb-ts-item-main">
                <div className="mb-ts-item-loai-cuoc">
                    {param.subGroup}
                </div>
                <div>
                    <LotSelect value={param.kieuGiu} id="thamso"
                        onChange={(e) => {
                            const kieuGiu = e.target.value;
                            const tmp = { ...param }
                            tmp.kieuGiu = kieuGiu;
                            onDataChange(tmp);
                        }}>
                        {options(param)}
                    </LotSelect>

                </div>
                <input className="lot-input" value={param.diemGiu}
                    onChange={(e) => {
                        const diemGiu = e.target.value;
                        const tmp = { ...param }
                        let diem = Number(diemGiu);
                        if (isNaN(diem)) {
                            diem = 0;
                        }
                        tmp.diemGiu = diem;
                        onDataChange(tmp);
                    }}
                />
            </div>
            {(param.kieuGiu == "STT" || param.kieuGiu == "PT") &&
                <div className="common-container-row left-panel">
                    <div>Giữ nhỏ nhất:</div>
                    <input className="lot-input" value={param.min}
                        onChange={(e) => {
                            const diemMin = e.target.value;
                            const tmp = { ...param }
                            let diem = Number(diemMin);
                            if (isNaN(diem)) {
                                diem = 0;
                            }
                            tmp.min = diem;
                            onDataChange(tmp);
                        }}
                    />
                </div>}
            {param.kieuGiu == "PT" &&
                <div className="common-container-row left-panel">
                    <div>Giữ lớn nhất:</div>
                    <input className="lot-input" value={param.max}
                        onChange={(e) => {
                            const diemMax = e.target.value;
                            const tmp = { ...param }
                            let diem = Number(diemMax);
                            if (isNaN(diem)) {
                                diem = 0;
                            }
                            tmp.max = diem;
                            onDataChange(tmp);
                        }} />
                </div>}
        </div>
    )
}

export default memo(ThamSoTheoLoaiCuocMB)